import React from 'react';
import { useTranslate } from '@hooks';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { FormFilter as Form, DateRangePicker } from '@dotone/react-ui-core';
import { OfferSearchInput } from '../forms';

const AffiliationFilterForm = ({ defaultValues, ...otherProps }) => {
  const { t } = useTranslate('common');

  return (
    <Form dateable defaultValues={defaultValues} {...otherProps}>
      <Row>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('date.date')}</Label>
            <DateRangePicker forReport names={{ from: 'startDate', to: 'endDate' }} />
          </FormGroup>
        </Col>
        <Col md={6} lg={4} xl={3}>
          <FormGroup>
            <Label>{t('model.offer')}</Label>
            <OfferSearchInput multi name="offerIds" />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default AffiliationFilterForm;
